<div class="px-3">
  <h2>{{ 'manageEntities.title' | translate }}</h2>
  <gstar-grid
    #gstarGrid
    dataIdKey="entityId"
    [source]="entities().items"
    [totalCount]="entities().total"
    [lazy]="true"
    [drawerSetting]="drawerSetting"
    [headers]="headers"
    [noDataMessage]="'manageEntities.noEntitiesMessage' | translate"
    [query]="manageEntitiesService.query()"
    (queryChange)="queryHandler($event)" />
</div>

<ap-modal
  #modal
  [style]="'width: 540px'"
  appModalId="modal-no-client"
  [title]="'manageEntities.selectClientWarningTitle' | translate">
  <p>{{ 'manageEntities.selectClientWarningMessage' | translate }}</p>
</ap-modal>
